import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { InfoDialogComponent } from 'app/modules/landing/corporate/status-info/info-dialog/info-dialog.component';

@Component({
    selector: 'app-insurance-popup',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, TranslateModule, MatIconModule],
    templateUrl: './insurance-popup.component.html',
    styleUrl: './insurance-popup.component.scss',
})
export class InsurancePopupComponent implements OnInit {
    selectedLanguage: string = 'en';
    productSlug: string = '';

    constructor(
        private dialogRef: MatDialogRef<InfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public product: any
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this.productSlug = this.product.productName
            ?.replaceAll(' ', '_')
            .toLowerCase();
    }
    closeDialog() {
        this.dialogRef.close();
    }
}
